module.exports = __webpack_public_path__ + "img/projects2.f47277c3.svg";